export default __webpack_public_path__ + "arrowhead-pointing-to-the-right.png";